import { unknown } from './unknown';
import { INLINE_CARD_FROM_TEXT_STAMP } from '../../parser/tokenize/issue-key';
export var inlineCard = function inlineCard(node) {
  if (!node.attrs.url) {
    return unknown(node);
  }
  var match = node.attrs.url.match(INLINE_CARD_FROM_TEXT_STAMP);
  if (!match) {
    return "[".concat(node.attrs.url, "|").concat(node.attrs.url, "|smart-link]");
  }
  return "[".concat(match[2], "]");
};